import { useCallback } from 'react'
import type {
  StatementDocumentFormat,
  StatementSummary,
} from 'src/page-components/Accounts/AccountStatementsTab/accountStatementsDemoData'

export interface StatementDownloadResult {
  download: (format: StatementDocumentFormat) => void
}

export const getHttpsStatementDocumentUrl = (
  statement: StatementSummary,
  format: StatementDocumentFormat,
): string | undefined => {
  const documentUrl = statement.documentUrls[format]?.trim()

  if (!documentUrl) {
    return undefined
  }

  try {
    return new URL(documentUrl).protocol === 'https:' ? documentUrl : undefined
  } catch {
    return undefined
  }
}

/** Opens the statement document URL published by Card Management. */
export const useStatementDownload = (
  statement: StatementSummary,
): StatementDownloadResult => {
  const download = useCallback(
    (format: StatementDocumentFormat) => {
      const documentUrl = getHttpsStatementDocumentUrl(statement, format)

      if (!documentUrl) {
        return
      }

      window.open(documentUrl, '_blank', 'noopener,noreferrer')
    },
    [statement.documentUrls],
  )

  return { download }
}
